module.exports = __webpack_public_path__ + "img/8S.dfeb4fd5.svg";